<template>
    <div class="dialog_content" @click="clickToHidden" ref="countDialog" v-if="isShow">
    <div class="count_time_content" >
        <p class="tip">[温馨提示]目前已经长时间没有操作设备，即将自动返回主页面。如需继续使用，请在倒计时结束前进行操作！</p>
        <p class="time">{{ time }}</p>
        <!-- <span>https://blog.csdn.net/weixin_47978760/article/details/126579516</span> -->
    </div>
    <div class="bg"></div>
</div>    
</template>

<script>
import router from "@/router";
import { getToken } from "@/utils/auth";
import { removeToken } from "@/utils/auth";
export default ({
    name: 'CountTime',
    data() {
        return{
            time:30,//120,
            isShow:false,
            timer:''
        }
    },
    methods: {
        // 倒计时 
        OpenDialog(){  
            this.time=30   
            this.isShow=true
              this.timer=setInterval(()=>{
                this.time--;
                if(this.time==0){
                    clearInterval(this.timer);
                    // alert('时间到！')
                    this.isShow=false
                    router.replace({
                        name: "modulelist",
                        params: {
                            account: getToken("account"),
                        },
                    });
                    // 移除登录用户信息
                    if(getToken('userInfoStudent')){
                        removeToken('userInfoStudent')
                    }
                    

                }
            },1000)            
        },  
        clickToHidden(){
            this.isShow=false            
            clearInterval(this.timer)
        }     
    },

    mounted() {
        // this.backHome()
    },
    // destroyed(){

    // }

})
</script>
<style scoped>
.dialog_content{
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
}
    .count_time_content{
        background: url('@/assets/img/home/count_time.png') no-repeat;
        background-size: cover;
        /* width: 656px;
        height: 443px; */
        width:30vw;
        height:20vw;
        background-position: 100% 100%;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%,-50%);
        z-index: 9999;
        padding: 2.5vw;
    box-sizing: border-box;
    /* cursor: pointer; */
    
    }
    .time{
        font-size: 4vw;
    color: #ffa800;
    text-align: center;
    margin-top: 1vw;
    }
    .tip{
        line-height: 2vw;
        font-size: 1.3vw;
        letter-spacing: 0.1vw;
    }
    .bg{
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0;
        left: 0;
        z-index: 9998;
        background: rgba(0,0,0,.5);
    }
</style>
